var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00065 0.666016C5.36884 0.666016 5.66732 0.964492 5.66732 1.33268V10.666C5.66732 11.0342 5.36884 11.3327 5.00065 11.3327C4.63246 11.3327 4.33398 11.0342 4.33398 10.666V1.33268C4.33398 0.964492 4.63246 0.666016 5.00065 0.666016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529247 6.19461C0.789596 5.93426 1.21171 5.93426 1.47206 6.19461L5.00065 9.72321L8.52925 6.19461C8.7896 5.93426 9.21171 5.93426 9.47206 6.19461C9.73241 6.45496 9.73241 6.87707 9.47206 7.13742L5.47206 11.1374C5.21171 11.3978 4.7896 11.3978 4.52925 11.1374L0.529247 7.13742C0.268897 6.87707 0.268897 6.45496 0.529247 6.19461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b4cd702bbdae2c04d1301e8879a9c57a.svg";
export { ForwardRef as ReactComponent };